import { render } from "./TasksProjects.vue?vue&type=template&id=9683b82e"
import script from "./TasksProjects.vue?vue&type=script&lang=js"
export * from "./TasksProjects.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__